import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Textbutton element, used for text-only buttons
 *
 * @prop label - used to define the text of this button
 * @prop disabled - optional, used to disable the button (no click events)
 *
 */
let SDBContentTextButton = class SDBContentTextButton extends LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.disabled = false;
        this.light = false;
    }
    render() {
        return html ` <button>${this.label}</button> `;
    }
};
SDBContentTextButton.styles = [
    elements,
    css `
            :host button {
                position: relative;
                display: inline-block;
                padding: 10px 15px;
                margin: 5px;
                background: transparent;
                border: none;
                color: var(--text-primary);
                cursor: pointer;
                text-transform: uppercase;
                font: var(--font-default);
                transition: scale 0.1s ease-in-out;
                -webkit-transform: rotateZ(360deg);
            }

            :host([light]) button {
                color: var(--text-light, #ffffff);
            }

            :host([disabled]) {
                pointer-events: none;
            }

            :host([disabled]) button {
                color: var(--element-disabled);
            }

            :host button:focus {
                outline: none !important;
            }

            :host button:hover {
                transform: var(--sdb-button-scale-factor, scale(1.05));
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentTextButton.prototype, "label", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBContentTextButton.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentTextButton.prototype, "light", void 0);
SDBContentTextButton = __decorate([
    customElement('sdb-content-textbutton')
], SDBContentTextButton);
export { SDBContentTextButton };
//# sourceMappingURL=sdb-content-textbutton.js.map